import type { AutocompleteWorkspace } from "../types";
import { DevelopmentType } from "@gql/sites-api/graphql";
import { Icon } from "react-migration/components/Icon";
import clsx from "clsx";
import { getDevelopmentTypeIconProps } from "react-migration/domains/projects/components/ProjectModal/constants";

type WorkspaceBadgeProps = {
  workspace: AutocompleteWorkspace;
  className?: string;
};

export function WorkspaceBadge({ workspace, className }: WorkspaceBadgeProps) {
  const firstType = workspace.developmentType[0];
  const { icon, iconColour } =
    firstType !== undefined
      ? getDevelopmentTypeIconProps(firstType as DevelopmentType)
      : { icon: undefined, iconColour: undefined };

  return (
    <div
      className={clsx(
        "flex items-center px-1 py-0.5 gap-1 min-w-0 max-w-32 shrink-0 rounded-sm bg-background-badge-grey-disabled",
        className
      )}
    >
      {icon != null && <Icon size="sm" icon={icon} extraClasses={iconColour} />}
      <span className="truncate text-xs font-medium text-text-base-secondary-a">{workspace.title}</span>
    </div>
  );
}
